import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIcon } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Application } from './models';
import { CurrentApplicationService } from './services';

@Component({
    selector: 'app-application',
    templateUrl: './application.component.html',
    styleUrls: ['./application.component.scss'],
    standalone: true,
    imports: [
        TranslocoModule,
        MatIcon,
        CommonModule,
        RouterModule,
        FlexLayoutModule
    ]
})
export class ApplicationComponent implements OnDestroy {
    application: Application | undefined;
    subscription: Subscription | undefined;

    constructor(
        private _currentApplication: CurrentApplicationService,
        private _router: Router
    ) {
        this._currentApplication.reset();
        this._currentApplication.load();
        this.subscription = this._currentApplication.latest
            .pipe(
                filter(
                    (application) =>
                        application !== null &&
                        application !== undefined &&
                        application.applicationId != undefined
                )
            )
            .subscribe((application) => {
                this.application = new Application({ ...application });
                this._router.navigateByUrl(this.nextPage(this.application));
            });
        document
            .getElementsByTagName('body')[0]
            .classList.remove('blue-background-active');
    }

    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }

    nextPage(application: Application | undefined) {
        // If the application was successfully submitted, show the submitted confirmation page.
        if (application?.isSubmitted) {
            return `${runtimeConfig.clientCode}/application-submitted`;
        }

        // Otherwise, route through the incomplete sections based on completion flags.
        // Note: if isDisclosureComplete=true but isSubmitted=false, keep user on disclosure page
        // (a rare stuck state) rather than showing a false "confirmed" page.
        if (application?.isEducationComplete)
            return `${runtimeConfig.clientCode}/application/disclosure`;
        else if (application?.isBackgroundComplete)
            return `${runtimeConfig.clientCode}/application/your-education`;
        else if (application?.isPersonalInfoComplete)
            return `${runtimeConfig.clientCode}/application/background`;
        else if (
            (application?.selectedProviderIds &&
                application?.selectedProviderIds?.length > 0) ||
            sessionStorage.getItem('applicationProviderIds') !== null
        )
            return `${runtimeConfig.clientCode}/application/personal-information`;
        else return `${runtimeConfig.clientCode}/provider`;
    }
    navigation(route: string) {
        this._router.navigateByUrl(`${runtimeConfig.clientCode}/${route}`);
    }

    isStepActive(route: string): boolean {
        return this._router.isActive(`/${runtimeConfig.clientCode}/${route}`, {
            paths: 'subset',
            queryParams: 'ignored',
            fragment: 'ignored',
            matrixParams: 'ignored'
        });
    }
}
